export default __webpack_public_path__ + "static/media/clean_the_table_responsive.e37e4f64.png";